import { Component } from '@angular/core';
import { PartSubType } from 'src/app/models/maintenancelogs.model';
import { DroneModelBaseComponent } from '../drone-model-base';

@Component({
  selector: 'app-drone-model-all',
  templateUrl: './drone-model-all.component.html',
  styleUrl: './drone-model-all.component.scss',
  standalone: false,
})
export class DroneModelAllComponent extends DroneModelBaseComponent {
  activeIndex = 0;

  // Dummy items just to generate the dots
  items = [0, 1];

  previous() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }

  next() {
    if (this.activeIndex < this.items.length - 1) {
      this.activeIndex++;
    }
  }

  showComponent(index: number) {
    this.activeIndex = index;
  }

  override ngOnInit(): void {
    // This container component delegates rendering and data-loading to
    // nested vector/scorpion model components.
  }

  getConfigurationType(): string[] {
    return [PartSubType.All];
  }
}
